import { c as _c } from "react/compiler-runtime";
import NumberInput from "@components/hookform/NumberInput";
import { ErrorMessage, RadioCard } from "@justhome/react-ui";
import { yesNoOptions } from "@lib/options";
import { QualificationFormData } from "@modules/booking/context/types";
import useBookingTranslation from "@modules/booking/lib/hooks/useBookingTranslation";
import { useForm } from "react-hook-form";
import { Form, FormField, FormRow } from "../Form";
import FormSection from "../FormSection";
type EquityFormValues = Pick<QualificationFormData, "equity" | "wantsToSellAProperty">;
interface EquityFormProps {
  onSubmit: (data: EquityFormValues) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  isLoading?: boolean;
  isError?: boolean;
}
const EquityForm = t0 => {
  const $ = _c(43);
  const {
    onSubmit,
    canGoBack,
    onGoBack,
    isLoading,
    isError
  } = t0;
  const {
    t
  } = useBookingTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    control,
    register,
    handleSubmit,
    formState: t2
  } = useForm(t1);
  const {
    errors
  } = t2;
  let t3;
  if ($[1] !== handleSubmit || $[2] !== onSubmit) {
    t3 = handleSubmit(onSubmit);
    $[1] = handleSubmit;
    $[2] = onSubmit;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("equityForm.equityLabel");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("equityForm.equityPlaceholder");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("equityForm.equityRequiredError");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = {
      required: t6
    };
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = errors.equity?.message;
  let t9;
  if ($[12] !== control || $[13] !== t4 || $[14] !== t5 || $[15] !== t7 || $[16] !== t8) {
    t9 = <FormRow><FormField><NumberInput name="equity" label={t4} placeholder={t5} suffix={"\u20AC"} control={control} rules={t7} errorMessage={t8} /></FormField></FormRow>;
    $[12] = control;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t("equityForm.wantsToSellLabel");
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10) {
    t11 = <label htmlFor="wantsToSellAProperty" className="block text-title-1 mb-xs">{t10}</label>;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== register || $[23] !== t) {
    t12 = yesNoOptions.map(option => <RadioCard size="sm" key={option} value={option} type="radio" {...register("wantsToSellAProperty", {
      required: t("equityForm.wantsToSellRequiredError")
    })}>{t(`yesNo.${option}`)}</RadioCard>);
    $[22] = register;
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12) {
    t13 = <div className="flex gap-3xs">{t12}</div>;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== errors.wantsToSellAProperty) {
    t14 = errors.wantsToSellAProperty && <ErrorMessage>{errors.wantsToSellAProperty?.message}</ErrorMessage>;
    $[27] = errors.wantsToSellAProperty;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t11 || $[30] !== t13 || $[31] !== t14) {
    t15 = <FormRow><FormField>{t11}{t13}{t14}</FormField></FormRow>;
    $[29] = t11;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t15 || $[34] !== t3 || $[35] !== t9) {
    t16 = <Form id="equity-form" onSubmit={t3}>{t9}{t15}</Form>;
    $[33] = t15;
    $[34] = t3;
    $[35] = t9;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== canGoBack || $[38] !== isError || $[39] !== isLoading || $[40] !== onGoBack || $[41] !== t16) {
    t17 = <FormSection formId="equity-form" canGoBack={canGoBack} onGoBack={onGoBack} isLoading={isLoading} isError={isError}>{t16}</FormSection>;
    $[37] = canGoBack;
    $[38] = isError;
    $[39] = isLoading;
    $[40] = onGoBack;
    $[41] = t16;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  return t17;
};
export default EquityForm;